import { render, staticRenderFns } from "./RedeemCoupon.vue?vue&type=template&id=2523f294&scoped=true&"
import script from "./RedeemCoupon.vue?vue&type=script&lang=js&"
export * from "./RedeemCoupon.vue?vue&type=script&lang=js&"
import style0 from "./RedeemCoupon.vue?vue&type=style&index=0&id=2523f294&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2523f294",
  null
  
)

export default component.exports